<template>
  <div class="card custom-form__card card-shadow">
    <div class="card-header">
      <div class="card-with-button">
        <h5>{{ emailsList.length > 0 ? emailsList[0].subject : 'E-mail' }}</h5>
      </div>
    </div>

    <div class="card-body d-flex flex-column" style="height: 80vh;">
      <div
        class="email-list-scroll-wrap flex-grow-1 d-flex flex-column"
        :class="{ 'is-email-list-initial-loading': loadingInitial }"
      >
        <div
          ref="emailContainer"
          id="emailContainer"
          class="email-list-scroll-pane container py-1 position-relative flex-grow-1"
          @scroll="onEmailListScroll"
        >
          <div
            class="email-list-col-loader"
            aria-hidden="true"
            v-show="loadingInitial"
          >
            <div class="spinner-border spinner-border-sm text-primary" role="status">
              <span class="sr-only">Carregando…</span>
            </div>
          </div>

          <div v-for="email in emailsList" :key="email.id">
            <EmailMsg :email="email" @toggle-read="toggleReadEmail" />
          </div>
        </div>

        <div
          class="email-list-scroll-loader"
          aria-hidden="true"
          v-show="loadingMore"
        >
          <span class="spinner-border spinner-border-sm text-secondary" role="status"></span>
          <span class="ml-1 small text-muted">Carregando…</span>
        </div>
      </div>

      <div class="container py-2 collapse" id="novoEmail">
        <div class="form-group" v-if="emailsList.length === 0 && !loadingInitial">
          <label for="emailSubject">Assunto:</label>
          <input
            type="text"
            class="form-control form-control-sm"
            id="emailSubject"
            name="emailSubject"
            v-model="emailSubject"
            :placeholder="(oportunidade && oportunidade.nome) ? oportunidade.nome : 'Assunto'"
          />
        </div>

        <div class="form-group" v-if="emailAccounts.length > 0 && emailsData.length === 0">
          <label for="fromEmailAccount">De:</label>
          <select
            class="form-control form-control-sm"
            id="fromEmailAccount"
            v-model="emailAccount"
          >
            <option v-for="account in emailAccounts" :key="account.id" :value="account.id">
              {{ account.label }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="toEmail">Para:</label>
          <input
            type="text"
            class="form-control form-control-sm"
            id="toEmail"
            name="toEmail"
            v-model="emailCliente"
            readonly
          />
        </div>

        <div class="form-group">
          <label for="ccEmails">CC:</label>
          <input
            type="text"
            class="form-control form-control-sm"
            id="ccEmails"
            name="ccEmails"
            placeholder="Digite os e-mails separados por vírgula (ex: exemplo@eloca.com, outro@eloca.com)"
            v-model="ccEmails"
          />
        </div>

        <input
          type="file"
          ref="fileInput"
          id="fileInput"
          multiple
          style="display: none;"
          @change="onFileChange"
        />

        <div class="text-editor-email">
          <ckeditor :editor="editor" :config="editorConfig" v-model="messageBody"/>
        </div>

        <label id="attachmentsLabel" class="mt-2 font-weight-bold" v-show="selectedFilesList.length > 0">
          Anexos:
        </label>

        <ul>
          <li v-for="(file, index) in selectedFilesList" :key="index" class="d-flex align-items-center mt-1">
            <span>{{ file.name }} ({{ (file.size / 1048576).toFixed(2) }} MB)</span>
            <button class="btn btn-danger btn-sm ml-2" @click="removeFile(index)">
              <i class="fa fa-trash"></i>
            </button>
          </li>
        </ul>

        <div class="d-flex justify-content-end mt-2">
          <button
            type="button"
            class="btn btn-primary btn-sm mr-2"
            id="attachButton"
            @click="openFileDialog"
            :disabled="isOldSafari"
            :title="isOldSafari ? 'Use o Safari 18 ou superior, ou outro navegador' : ''"
          >
            <i class="fa fa-paperclip"></i> Anexar Arquivo
          </button>

          <button
            type="button"
            class="btn btn-success btn-sm"
            id="sendButton"
            @click="sendEmail"
            :disabled="isSending"
          >
            <i class="fa fa-paper-plane"></i> Enviar E-mail
          </button>

          <button
            type="button"
            class="btn btn-danger btn-sm ml-2"
            @click="closeNewEmail"
          >
            <i class="fa fa-times"></i> Cancelar
          </button>
        </div>
      </div>

      <div class="container py-2">
        <div class="d-flex justify-content-end mt-2 mr-3">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            id="newEmailButton"
            @click="openNewEmail"
          >
            <i class="fa fa-plus"></i> Novo E-mail
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

import EmailMsg from "./EmailMsg.vue";

const PAGE_SIZE = 10;
const SCROLL_THRESHOLD_PX = 100;

export default {
  name: "EmailConversa",
  components: {
    EmailMsg,
  },
  props: {
    oportunidade_id: {
      type: Number,
      required: true,
    },
    assinatura_email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      oportunidade: {},
      emailsData: [],
      nextOffset: 0,
      hasMore: true,
      loadingInitial: false,
      loadingMore: false,
      ultimoCc: '',
      selectedFiles: [],
      fileInput: null,
      editor: ClassicEditor,
      ccEmails: '',
      messageBody: '',
      emailCliente: '',
      editorConfig: {
        toolbar: [
          'undo', 'redo',
          '|',
          'heading',
          '|',
          'fontsize', 'fontColor', 'fontBackgroundColor',
          '|',
          'bold', 'italic',
          '|',
          'link', 'blockQuote',
          '|',
          'bulletedList', 'numberedList', 'outdent', 'indent'
        ],
      },
      isOldSafari: false,
      emailSubject: '',
      isSending: false,
      scrollAfterLoad: 'top',
      emailTabLink: null,
      emailAccounts: [],
      emailAccount: null,
    };
  },
  created() {
    this.getOportunidade(this.oportunidade_id);
    this.fetchEmailsPage(true);
  },
  mounted() {
    this.checkSafariVersion();
    this.fileInput = this.$refs.fileInput;
    this.emailTabLink = document.getElementById('bloco-email-tab');
    if (this.emailTabLink) {
      $(this.emailTabLink).on('shown.bs.tab', this.onEmailTabShown);
    }
  },
  beforeDestroy() {
    if (this.emailTabLink) {
      $(this.emailTabLink).off('shown.bs.tab', this.onEmailTabShown);
    }
  },
  computed: {
    emailsList() {
      return Array.isArray(this.emailsData) ? this.emailsData : [];
    },
    selectedFilesList() {
      return Array.isArray(this.selectedFiles) ? this.selectedFiles : [];
    },
  },
  methods: {
    parseEmailsFromResponse(response) {
      const data = (response && response.data) ? response.data : {};
      const rawEmails = data.emails;

      if (Array.isArray(rawEmails)) {
        return rawEmails;
      }

      if (rawEmails && typeof rawEmails === 'object') {
        return Object.values(rawEmails);
      }

      return [];
    },
    toggleReadEmail(emailId) {
      const email = this.emailsList.find((e) => e.id === emailId);
      if (email) {
        email.lido = !email.lido;
      }
    },
    openFileDialog() {
      if (this.fileInput) {
        this.fileInput.click();
      }
    },
    onFileChange(event) {
      if (!event.target || !event.target.files) {
        return;
      }
      const newFiles = Array.from(event.target.files);
      const currentFiles = Array.isArray(this.selectedFiles) ? this.selectedFiles : [];
      this.selectedFiles = [...currentFiles, ...newFiles];
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
    getDefaultMessageBody() {
      const assinatura = String(this.assinatura_email || '').trim();
      if (!assinatura) {
        return '';
      }
      return `<p><br></p><p><br></p>${assinatura}`;
    },
    openNewEmail() {
      this.ccEmails = this.ultimoCc || '';
      this.messageBody = this.getDefaultMessageBody();
      $('#novoEmail').collapse('show');
      $('#newEmailButton').hide();
    },
    closeNewEmail() {
      $('#novoEmail').collapse('hide');
      $('#newEmailButton').show();
      this.clearForm();
    },
    clearForm() {
      this.ccEmails = "";
      this.messageBody = "";
      this.emailSubject = "";
      this.selectedFiles = [];
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
    },
    resetEmailList() {
      this.emailsData = [];
      this.nextOffset = 0;
      this.hasMore = true;
      this.loadingInitial = false;
      this.loadingMore = false;
      this.ultimoCc = '';
    },
    scrollToTop() {
      const container = this.$refs.emailContainer;
      if (container) {
        container.scrollTop = 0;
      }
    },
    scrollToBottom() {
      const container = this.$refs.emailContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },
    applyScrollAfterLoad() {
      if (this.scrollAfterLoad === 'none') {
        return;
      }
      this.$nextTick(() => {
        if (this.scrollAfterLoad === 'bottom') {
          this.scrollToBottom();
          this.scrollAfterLoad = 'top';
          return;
        }
        this.scrollToTop();
      });
    },
    onEmailTabShown() {
      this.scrollToTop();
    },
    onEmailListScroll() {
      if (this.loadingMore || this.loadingInitial || !this.hasMore) {
        return;
      }
      const container = this.$refs.emailContainer;
      if (!container) {
        return;
      }
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - SCROLL_THRESHOLD_PX
      ) {
        this.fetchEmailsPage(false);
      }
    },
    async reloadEmailsAfterSend() {
      this.resetEmailList();
      this.scrollAfterLoad = 'none';
      await this.fetchEmailsPage(true);
      while (this.hasMore) {
        await this.fetchEmailsPage(false);
      }
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    async fetchEmailsPage(isInitial) {
      if (isInitial) {
        if (this.loadingInitial) {
          return;
        }
        this.loadingInitial = true;
      } else {
        if (this.loadingMore || !this.hasMore) {
          return;
        }
        this.loadingMore = true;
      }

      try {
        const response = await api.get(`emails/${this.oportunidade_id}`, {
          params: {
            offset: this.nextOffset,
            per_page: PAGE_SIZE,
          },
        });

        const data = (response && response.data) ? response.data : {};
        const pageEmails = this.parseEmailsFromResponse(response);

        if (isInitial) {
          this.emailsData = pageEmails;
        } else {
          const currentEmails = Array.isArray(this.emailsData) ? this.emailsData : [];
          this.emailsData = [...currentEmails, ...pageEmails];
        }

        if (data.loaded != null) {
          this.nextOffset = Number(data.loaded);
        } else {
          this.nextOffset = this.nextOffset + pageEmails.length;
        }

        this.hasMore = !!data.has_more;
        if (data.ultimo_cc != null) {
          this.ultimoCc = data.ultimo_cc;
        }

        if (isInitial && pageEmails.length === 0) {
          this.$nextTick(() => {
            this.openNewEmail();
          });
        }

        this.applyScrollAfterLoad();
      } catch (error) {
        if (isInitial) {
          this.hasMore = false;
        }
      } finally {
        if (isInitial) {
          this.loadingInitial = false;
        } else {
          this.loadingMore = false;
        }
      }
    },
    async sendEmail() {
      if (this.isSending) {
        return;
      }
      this.isSending = true;
      $("#overlayer-loading").addClass("show-overlayer");
      let formData = new FormData();
      formData.append('ccEmails', this.ccEmails ?? '');
      formData.append('messageBody', this.messageBody);
      if (this.emailsList.length === 0) {
        formData.append('subject', this.emailSubject ?? '');
      }
      if (this.emailAccount) {
        formData.append('emailAccount', this.emailAccount);
      }
      this.selectedFilesList.forEach((file) => formData.append('files[]', file));
      await api.post(`email-send/${this.oportunidade_id}`, formData, {
        headers: {
          'Content-Type': "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2),
        }
      })
        .then(async (response) => {
          window.showToastSuccess('body', response.data.message);
          await this.reloadEmailsAfterSend();
          this.closeNewEmail();
        })
        .catch((error) => {
          let errorMessage = 'Erro ao enviar email';
          const responseData = error.response && error.response.data ? error.response.data : null;
          if (responseData && responseData.message) {
            errorMessage = responseData.message;
          }
          if (responseData && responseData.errors) {
            Object.values(responseData.errors).forEach((item) => {
              const message = Array.isArray(item) ? item.join(', ') : item;
              errorMessage = errorMessage.concat('</br>', message);
            });
          }
          window.showToastDanger('body', errorMessage);
        })
        .finally(() => {
          this.isSending = false;
          $("#overlayer-loading").removeClass("show-overlayer");
        })
    },
    async getEmails(oportunidade_id) {
      await api.get(`emails/${oportunidade_id}`)
        .then((response) => {
          this.emailsData = response.data.emails;
          this.emailAccounts = response.data.emailAccounts || [];
          if (this.emailAccounts.length > 0) {
            this.emailAccount = this.emailAccounts[0].id;
          }
          if (this.emailsData.length === 0) {
            this.$nextTick(() => {
              this.openNewEmail();
            });
          }
        })

      setTimeout(function () {
          var container = $("#bloco-email").find('#emailContainer');
          if (container.length > 0) {
              container.scrollTop(container.prop("scrollHeight"));
          }
      }, 100);
    },
    async getOportunidade(oportunidade_id) {
      try {
        const response = await api.get(`dados/${oportunidade_id}`);
        const oportunidade = (response && response.data) ? response.data : {};
        const cliente = oportunidade && oportunidade.cliente ? oportunidade.cliente : {};

        this.oportunidade = oportunidade || {};
        this.emailCliente = cliente.email || '';
      } catch (error) {
        this.oportunidade = {};
        this.emailCliente = '';
      }
    },
    checkSafariVersion() {
      const ua = navigator.userAgent;

      const isSafari = /Safari/.test(ua) && !/Chrome|Chromium|Edg/.test(ua);
      
      if (isSafari) {
        const match = ua.match(/Version\/([\d.]+)/);

        if (match && match[1]) {
          const versionParts = match[1].split('.');
          const majorVersion = parseInt(versionParts[0], 10);

          if (majorVersion <= 17) {
            this.isOldSafari = true;
          }
        }
      }
    }
  },
};
</script>
